import * as Icons from "./icons-utils";

export const Icon = (props) => {
    const { name, ...restProps } = props;
    if (!Icons[name]) throw new Error(`Icon ${name} not found`);
    return Icons[name]({ ...restProps });
};
